var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box-shadow-medium m-3 p-3 rounded-2 card-border f4",style:({ borderColor: _vm.currentColor })},[_c('h2',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default",function(){return [_vm._v(" Empty Info Card ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }